import i18nLanguages from "@cospired/i18n-iso-languages";
import { getCurrentLocale } from "../../Translation/helpers/getCurrentLocale";

export function getLanguageName(code: string) {
  const currentLanguage = getCurrentLocale();
  return i18nLanguages.getName(code, currentLanguage) || code;
}
